<template>
  <div>
    MyPort
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import HeaderMenu from "@/components/navigation/HeaderMenu.vue";
import ScreenAlert from "@/components/ScreenAlert.vue";

@Component({
  components: {
    HeaderMenu,
    ScreenAlert,
  },
})
export default class Home extends Vue {
  private something = true;
}
</script>
